import base64 from '@/utils/base64'
import nativeApi from '@/utils/native-api'
//api
import qrCode from '@/api/miniProgramQrCode'

function getShareImg(params) {
  params = JSON.stringify(params)

  return qrCode['331201']({
    params
  })
}

export default {
  props: ['isShow', 'info'],
  computed: {
    showStyle() {
      let style = ['']

      if (this.isShow) {
        style = ['show']
      }

      return style
    }
  },
  methods: {
    //分享到微信好友
    shareMiniprogram(smallApp = {}) {
      if (smallApp && !smallApp.backUpUrl) {
        smallApp.backUpUrl = location.href
      }

      return this.sharePage({
        smallApp,
        type: 'weixin'
      })
    },
    shareImgMiniprogram({params, smallApp = {}}) {
      this.$showLoading()

      getShareImg(params).then((data) => {
        let result
        this.$hideLoading()

        if (data && data.img) {
          data = data.img
          smallApp.background = data
          if (smallApp && !smallApp.backUpUrl) {
            smallApp.backUpUrl = location.href
          }
          result = this.sharePage({
            smallApp,
            type: 'weixin'
          })
        } else {
          result = Promise.reject({
            message: '图片生成失败'
          })
        }
        return result
      }).catch(this.$apiErrorHandler)

    },
    shareToWeixin(params = {}) {
      params.type = 'weixin'
      return this.sharePage(params)
    },
    shareImgToWeixin(params = {}) {
      return this.shareImg(params, 'weixin')
    },
    shareToPyq(params = {}) {
      params.type = 'pengyouquan'
      return this.sharePage(params)
    },
    shareImgToPyq(params = {}) {
      this.shareImg(params, 'pengyouquan')
    },
    //分享到朋友圈
    shareImg(params = {}, type = 'pengyouquan') {
      this.$showLoading()

      if (params && params.appletCodeUrl) {
        // 生成二维码对应的服务器文档： https://git.133ec.com/gtgjx/gtgjxdoc/blob/master/act/applet/%E5%B0%8F%E7%A8%8B%E5%BA%8F%E7%A0%81%E6%8E%A5%E5%8F%A3.md#%E5%B0%8F%E7%A8%8B%E5%BA%8F%E5%90%8D%E7%A7%B0
        params.appletCodeUrl = 'https://train.rsscc.com/trainact/applet/code/queryAppletQrCodeV2.action'
          + '?pageUrl=' + base64.encode(params.appletCodeUrl) // 根路径前不要填加 /，不能携带参数，参数请放在scene字段里
          + '&appletName=' + (params.appletName || 'gtgj')
          + '&scene=' + (params.scene || 0)
          + '&envVersion=' + 'release' // 正式版为 release，体验版为 trial，开发版为 develop
      }

      return getShareImg(params).then((data) => {
        let result

        if (data && data.imgData) {

          data = data.imgData

          result = this.sharePage({
            imageBase64: data,
            type
          })
        } else {
          result = Promise.reject({
            message: '图片生成失败'
          })
        }

        setTimeout(() => {
          this.$hideLoading()
        }, 500)


        return result
      }).catch(this.$apiErrorHandler)
    },
    sharePage(params = {}) {
      params.hlo_module = 'gtgj'
      //默认分享到高铁管家小程序
      params.xcxAppId = params.xcxAppId || 'gh_805260863c43'

      return nativeApi.invoke('sharePage', params)
    },
    show() {
      this.$emit('show', true)
    },
    close() {
      this.$emit('close', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/shareHelper.js